import styled from "styled-components";
const GamezoneOnlineSignupPageDisplay = styled.div`
background: ${p => p.bgImg};
background-size: cover;
.formsLayoutjawal
{
  min-height: 121vh;
}
.gamezoneSignup
{
  background: rgb(238 90 17);
}
.header_gamezone
{
display: flex;
justify-content: space-between;
  align-items: center;
    margin-top: 5px!important;
  width: 100%;
  border-bottom: 2px solid #65378b;
}
  .countryCode{
  width:25%;
  padding-right: 0px;
  padding-left: 0px;
  margin-left: 4px;
  text-align: center;
  margin-right: 4px;
  }
  .numberInput{
    width:75%;
  }
  .number-inputs{
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
.links-Section{
 // position: absolute;
  //border: 1px solid red;
 position: relative;
    top: 30%;
}
.links-Sectionjawwalgamezorid
{
  top: 12%!important;
  width: 85%;
  .play
  {

   background: var(--games_icon) center center no-repeat;
   height: 164px;
   background-size: var(--background-size)!important;
  }
  input
  {
    margin-top: 10px;
  }
  .gamezoneInput
  {
    background: white;
    color: black;
    padding: 1px 8px;
  }
  
}

.language-switcher {
 display: flex;
  gap: 8px;
  align-items: center;
}

.language-switcher button {
  background: transparent;
  border: 1px solid white;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
}

.language-switcher button.active {
  background: white;
  color: #333;
}

.links-Section a {
  color:white
}
.links-Section button{
  margin-bottom: 15px;
  display:block;
}
.links-Sectionjawwalgamezorid button{
  display: block;
  margin: 30px auto;
  min-width: 190px;
}
.formsLayout {
  margin: 0 20px;
  .verfiySection
  {
  //  top: 26%!important;
  width: 100%;
  //position: absolute;
  }
  .gamezoneLogo
  {
    max-width: 163px!important;
  }
  .inputs {
    select {
      width: 35%;
      height: 43px;
    }
    input {
      width: 50%;
    }
  }
    
  .footer{
   
      font-size: 13px;
      margin-top: 20px;
      display:flex;
      flex-direction:column;

   

  }
  .zainiqFooter
    {
      p
      {
        font-size : 14px;
      }
    }
}
`;	export default GamezoneOnlineSignupPageDisplay;
